var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "trs-side-panel" } }, [
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass: "side-panel grid grid__custom-1",
            class: _vm.rootClasses
          },
          [
            _c("div", { staticClass: "side-panel--header" }, [
              _c("div", { staticClass: "grid--container" }, [
                _c("div", { staticClass: "grid--row side-panel--header-row" }, [
                  _c(
                    "div",
                    { staticClass: "grid--col" },
                    [
                      _c(
                        "dropdown",
                        _vm._b(
                          { attrs: { facets: ["side-panel"] } },
                          "dropdown",
                          _vm.languages,
                          false
                        )
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.currentItem.back_label
              ? _c(
                  "div",
                  { staticClass: "side-panel--breadcrumbs" },
                  [
                    _c(
                      "transition-group",
                      {
                        staticClass: "grid--container",
                        attrs: { tag: "div", name: _vm.drillAnimationName }
                      },
                      [
                        _c(
                          "ol",
                          {
                            key: _vm.currentItem.menu_item_id,
                            staticClass:
                              "side-panel--breadcrumbs-row grid--row u-reset"
                          },
                          [
                            _c(
                              "li",
                              { staticClass: "side-panel--col grid--col" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "side-panel--back" },
                                  [
                                    _c(
                                      "simple-btn",
                                      {
                                        attrs: { facets: ["has-grid"] },
                                        on: {
                                          click: function($event) {
                                            return _vm.navigateTo(
                                              _vm.currentItem.parent_id,
                                              "up"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("ui-icon", {
                                          attrs: {
                                            symbol: "arrow-left",
                                            size: "medium"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.currentItem.back_label) +
                                            "\n                            "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "transition-group",
              {
                staticClass: "side-panel--menu-wrap",
                attrs: { tag: "div", name: _vm.drillAnimationName }
              },
              [
                _c(
                  "div",
                  {
                    key: _vm.currentItem.menu_item_id,
                    staticClass: "side-panel--menu"
                  },
                  [
                    _c("div", { staticClass: "grid--container" }, [
                      _c("div", { staticClass: "grid--row" }, [
                        _c(
                          "div",
                          { staticClass: "side-panel--col grid--col" },
                          [
                            _vm.currentItem.label
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "side-panel--category-title u-reset"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.currentItem.label) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.currentGroups, function(group, index) {
                      return _c(
                        "nav",
                        { key: index, staticClass: "side-panel--group" },
                        [
                          _c("div", { staticClass: "grid--container" }, [
                            _c("div", { staticClass: "grid--row" }, [
                              _c(
                                "div",
                                { staticClass: "side-panel--col grid--col" },
                                [
                                  group.title
                                    ? _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "side-panel--group-title u-reset"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(group.title) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "side-panel--collection u-reset"
                                    },
                                    _vm._l(group.items, function(
                                      item,
                                      linkIndex
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key: linkIndex,
                                          staticClass: "side-panel--item"
                                        },
                                        [
                                          item.path
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "side-panel--link u-reset",
                                                  class: _vm.linkFacets(
                                                    item.facets
                                                  ),
                                                  attrs: {
                                                    href: item.path,
                                                    target: item.external
                                                      ? "_blank"
                                                      : "_self"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.label) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "side-panel--link",
                                                  class: _vm.linkFacets(
                                                    item.facets
                                                  ),
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.navigateTo(
                                                        item.menu_item_id,
                                                        "down"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.label) +
                                                      "\n                                            "
                                                  ),
                                                  _c("ui-icon", {
                                                    attrs: {
                                                      symbol: "arrow-right",
                                                      size: "medium"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-568a4e44", { render: render, staticRenderFns: staticRenderFns })
  }
}